module.exports = __webpack_public_path__ + "static/media/ehealthpro_info_share_slider_phone1.59d71989.png";